module.exports = __webpack_public_path__ + "img/pay.a9f3dca6.png";